import React from 'react';

import Modal from 'components/common/Modal';
import ModalPartnership from 'components/Popup/ModalPartnership';

const PartnershipService: React.FC = () => {
  const { openModal, closeModal, ModalPortal } = Modal();

  return (
    <>
      <div className="sub-wrap type2">
        <h2>
          로컬스티치와 함께 할 <br />
          다양한 파트너를 <br />
          기다립니다
        </h2>
        <p>
          자기만의 전문성과 콘텐츠를 바탕으로 가게를 열고 싶은 예비창업자
          <br />
          로컬스티치 멤버들에게 각종 프로모션을 제공하여 제품 및 서비스를
          홍보하고 싶은 예비파트너
          <br />
          각종 전시 및 콘텐츠 제작 등 로컬스티치와 재미있는 콜라보레이션을
          함께하고 싶은 예비파트너
        </p>
        <div className="partnership">
          <div className="in-btn">
            <a onClick={openModal} style={{ cursor: 'pointer' }}>
              파트너십 문의하기
            </a>
          </div>
        </div>
      </div>
      <ModalPortal>
        <ModalPartnership closeModal={closeModal} />
      </ModalPortal>
    </>
  );
};

export default PartnershipService;
